import React from "react";

type Props = {};

const LoginExtPage = (props: Props) => {
  return <div>LoginExtPage</div>;
};

export default LoginExtPage;
